'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _TypicalResponseTime = require('../../typical-response-time/records/TypicalResponseTime');

var _TypicalResponseTime2 = _interopRequireDefault(_TypicalResponseTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetAvailabilityOptions = function (_Record) {
  _inherits(WidgetAvailabilityOptions, _Record);

  function WidgetAvailabilityOptions() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, WidgetAvailabilityOptions);

    return _possibleConstructorReturn(this, (WidgetAvailabilityOptions.__proto__ || Object.getPrototypeOf(WidgetAvailabilityOptions)).call(this, _extends({}, properties, {
      typicalResponseTime: properties.typicalResponseTime ? (0, _TypicalResponseTime2.default)(properties.typicalResponseTime) : null
    })));
  }

  return WidgetAvailabilityOptions;
}((0, _immutable.Record)({
  awayMessage: null,
  typicalResponseTime: null,
  officeHoursStartTime: null
}));

exports.default = WidgetAvailabilityOptions;
module.exports = exports['default'];